import React, { useState, useEffect } from 'react';
import { Link, graphql } from 'gatsby';
import { Container, Row, Col, Button } from 'reactstrap';
import { Parallax } from 'react-scroll-parallax';
import { HiArrowNarrowRight } from 'react-icons/hi';
import string from 'lodash/string';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import parse from 'html-react-parser';
import SEO from '../components/seo';
import '../styles/blog.scss';
// Asset
import categoryImg from '../images/category.png';
import featuredImg from '../images/featured-post.png';
import placeholderImg from '../images/thumbnail.jpg';
import circle from '../images/circle.svg';
import greenBubble from '../images/green-bubble.svg';
import purpleBubble from '../images/purple-circle.svg';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));
const BlogPage = (props) => {
  const { data } = props;
  const { truncate } = string;
  // const [modal, setModal] = useState(false)
  // const toggle = () => setModal(!modal)
  const [selectedCategoryName, setCategoryName] = useState('All the "stuff"');
  const [featuredPost, setFeaturedPost] = useState('');
  const [featuredPostImg, setFeaturedPostImg] = useState();
  const [postsList, setPostsList] = useState();
  const [paginate, setPagination] = useState(0);
  // console.log(data.allWordpressCategory.nodes);
  // console.log(data.allWordpressPost.edges);
  // console.log(selectedCategoryID);
  const getFeaturedPosts = (catName) => {
    const foundFeaturedPost = data.allWordpressCategory.nodes.find(
      (category) => category.name === catName
    );
    if (foundFeaturedPost) {
      setFeaturedPost(foundFeaturedPost.acf.featured_post);

      const foundFeaturedPostImg = data.allWordpressPost.edges.find(
        (post) =>
          post.node.title === foundFeaturedPost.acf.featured_post.post_title
      );

      setFeaturedPostImg(
        foundFeaturedPostImg.node.featured_media
          ? foundFeaturedPostImg.node.featured_media.source_url
          : featuredImg
      );
    }
  };
  const getPostsInCategory = async (name) => {
    const filterResult = [];
    // eslint-disable-next-line array-callback-return
    await data.allWordpressPost.edges.filter(({ node }) => {
      const foundPost = node.categories.find((post) => post.name === name);
      if (foundPost) {
        filterResult.push(node);
      }
    });
    setCategoryName(name);
    setPostsList(filterResult);
    setPagination(0);
    getFeaturedPosts(name);
  };
  useEffect(() => {
    if (!postsList) {
      getPostsInCategory(selectedCategoryName);
    }
    // console.log(postsList)
  });
  const classes = useStyles();
  const handleChange = (event) => {
    getPostsInCategory(event.target.value);
  };

  const nextPage = () => {
    if (paginate + 6 <= postsList.length) {
      setPagination(paginate + 6);
    }
  };
  const prevPage = () => {
    if (paginate - 6 >= 0) {
      setPagination(paginate - 6);
    }
  };
  return (
    <>
      <SEO
        title="Blog"
        description="Productivity tips for your growing business — and how technology can help."
        image={featuredImg}
      />
      <Container fluid className="section-banner">
        <Row>
          <Col md="12" lg="6">
            <h1 className="page-header">
              Your Hub of <br />
              <span className="text-orange">Productivity</span>
            </h1>
            <p>
              Productivity tips for your growing business — and how technology
              can help.
            </p>
          </Col>
          <Col md="12" lg="6">
            <div className="category-thumbnail">
              <img src={categoryImg} alt="cat-thumb" />
            </div>
            <Parallax className="circle wow" y={[20, -100]} tagOuter="figure">
              <img src={circle} data-wow-delay="0.5s" alt="charli-ai" />
            </Parallax>
            <Parallax
              className="purple-dot wow"
              y={[20, -200]}
              tagOuter="figure"
            >
              <img src={purpleBubble} alt="charli-ai" />
            </Parallax>
          </Col>
        </Row>
      </Container>
      <Container fluid className="section-featured-post">
        <Container>
          <Row>
            <Col md="12" lg="6" className="featured-img-wrapper">
              <img src={featuredPostImg} alt="charli-ai" />
            </Col>
            <Col md="12" lg="6" className="featured-content-wrapper">
              <h5>{selectedCategoryName}</h5>
              <h4>{featuredPost.post_title}</h4>
              <p>{featuredPost.post_excerpt}</p>
              <Link
                className="teal-link-button"
                to={featuredPost ? featuredPost.post_name : '/blog/'}
              >
                <h4>
                  Read more <HiArrowNarrowRight />
                </h4>
              </Link>
            </Col>
          </Row>
          <Row>
            <Col md="12" className="category-dropdown-wrapper">
              <h2>
                Learn more about{' '}
                <FormControl className={classes.formControl}>
                  <Select
                    value={selectedCategoryName}
                    onChange={handleChange}
                    displayEmpty
                    className={classes.selectEmpty}
                  >
                    {data.allWordpressCategory.nodes.map((item) =>
                      item.name && item.name !== 'Uncategorized' ? (
                        <MenuItem key={item.name} value={item.name}>
                          {item.name}
                        </MenuItem>
                      ) : (
                        ''
                      )
                    )}
                  </Select>
                </FormControl>
              </h2>
            </Col>
          </Row>
          <Parallax
            className="green-circle wow"
            y={[20, -100]}
            tagOuter="figure"
          >
            <img src={greenBubble} alt="charli-ai" />
          </Parallax>
        </Container>
      </Container>
      <Container fluid className="section-category-posts">
        <Container>
          <Row>
            <Col md="12">
              <h3>Latest Stories</h3>
            </Col>
          </Row>
          <Row>
            {postsList && postsList.length > 0 ? (
              postsList
                .slice(
                  paginate,
                  paginate + 6 >= postsList.length
                    ? postsList.length
                    : paginate + 6
                )
                .map((item) => (
                  <Col
                    key={item.slug}
                    lg="4"
                    md="6"
                    sm="12"
                    className="post-container"
                  >
                    {item.featured_media ? (
                      <img
                        className="post-thumbnail"
                        src={item.featured_media.source_url}
                        alt="charli-ai"
                      />
                    ) : (
                      <img
                        className="post-thumbnail"
                        src={placeholderImg}
                        alt="charli-ai"
                      />
                    )}
                    <h5 className="post-category">{selectedCategoryName}</h5>
                    <Link to={item.slug}>
                      <h4 className="post-title">{parse(item.title)}</h4>
                    </Link>
                    <div className="post-excerpt">
                      {parse(
                        truncate(item.excerpt, {
                          length: 120, // maximum 30 characters
                          separator: /,?\.* +/, // separate by spaces, including preceding commas and periods
                        })
                      )}
                    </div>

                    <Link className="teal-link-button" to={item.slug}>
                      <h4>
                        Read More <HiArrowNarrowRight />
                      </h4>
                    </Link>
                  </Col>
                ))
            ) : (
              <Col md="12" className="post-container">
                <h3>NO POST FOUND</h3>
              </Col>
            )}
          </Row>
          {postsList && postsList.length > 6 ? (
            <Row>
              <Col sm="12" className="pagination">
                <Button onClick={prevPage}>Previous</Button>
                <Button onClick={nextPage}>Next</Button>
              </Col>
            </Row>
          ) : (
            ''
          )}
        </Container>
      </Container>
    </>
  );
};
export default BlogPage;
export const pageQuery = graphql`
  query {
    allWordpressPost {
      edges {
        node {
          title
          excerpt
          slug
          date
          categories {
            name
            id
          }
          featured_media {
            source_url
          }
        }
      }
    }
    allWordpressCategory {
      nodes {
        name
        id
        acf {
          featured_post {
            post_author
            post_date
            post_excerpt
            post_title
            post_name
          }
        }
      }
    }
  }
`;
